import axios from "axios";

export const SECTION_URL = "/Section";
export const TEACHER_URL = "/Teacher";
export const TEACHER_COURSE_URL = "/TeacherCourse";

/** Belli Bir Öğretmen Dersi Listesini Elde Eder */
export function getTeacherCourses(queryParams) {
  return axios.post(`${TEACHER_COURSE_URL}/GetTeacherCourses`, queryParams);
}

/** Belli Bir Öğretmen Dersi Listesini Sayfalama Olmadan Elde Eder */
export function getAllTeacherCourses(queryParams) {
  return axios.post(`${TEACHER_COURSE_URL}/GetAllTeacherCourses`, queryParams);
}

/** Belli Bir Dönemde Sözleşmesi Olan Öğretmen Listesini Branşlarıyla Birlikte Elde Eder */
export function getTeachersWithBranches(term) {
  return axios.get(`${TEACHER_URL}/GetTeachersWithBranches/${term}`);
}

/** Şube ve Ders Listesini Elde Eder */
export function getSectionsAndCourses(queryParams) {
  return axios.post(`${TEACHER_COURSE_URL}/GetSectionsAndCourses`, queryParams);
}

/** Sınıf Düzeyi, Şube, Öğretmen, Branş ve Ders Listesini Elde Eder */
export function getAllList() {
  return axios.get(`${TEACHER_COURSE_URL}/GetAllList`);
}

/** Sınıf Düzeyi, Şube ve Ders Listesini Elde Eder */
export function getList() {
  return axios.get(`${TEACHER_COURSE_URL}/GetList`);
}

/** Tüm Şubeleri Elde Eder */
export function getAllSections() {
  return axios.get(`${SECTION_URL}/GetSectionAndLevelSections`);
}

/** Belli Bir Sınıf Düzeyine Ait Şubeleri Elde Eder */
export function getSections(level) {
  return axios.get(`${SECTION_URL}/GetSections/${level}`);
}

/** Belli Bir Öğretmenin Belli Bir Dönemde Girdiği Şube ve Derslerin Id lerini Elde Eder */
export function getSectionAndCourseIds(teacherId, term) {
  return axios.get(`${TEACHER_COURSE_URL}/${teacherId}/${term}`);
}

/** Belli Bir Öğretmen Dersi Listesini Kaydeder */
export function saveTeacherCourses(entityId, term, datas) {
  return axios.post(TEACHER_COURSE_URL, { entityId, term, datas });
}

/** Belli Bir Öğretmen Dersi Listesini Siler */
export function deleteTeacherCourses(ids) {
  return axios.post(`${TEACHER_COURSE_URL}/Delete`, { ids });
}